import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { useStore } from '../../../store';
import { IFetchTransactions } from '../interfaces';

export interface UseCategorizeExternalTransactionProps {
  accountExternalId: string;
  transactionId?: string;
  categoryDetails: {
    categoryId: string;
    businessPercent: number;
  };
}

export const useCategorizeExternalTransaction = () => {
  const { customerId } = useStore((state) => state.user);
  const { selectedSyncedCard } = useStore((state) => state);
  return useMutation(
    'useCategorizeExternalTransaction',
    async ({ accountExternalId, transactionId, categoryDetails }: UseCategorizeExternalTransactionProps) => {
      const { data } = await httpService.post(
        `${BASE_URL}/api/v1/user/${customerId}/account/${accountExternalId}/externalAccount/${selectedSyncedCard?.externalId}/transaction/${transactionId}/categorise`,
        {
          ...categoryDetails,
        },
      );
      return data as IFetchTransactions;
    },
  );
};
